﻿// import { LogLevel } from "@azure/msal-browser";

// export const msalConfig = {
//   auth: {
//     clientId: "ffa0c20f-57a7-4174-8759-741bb3d9b83f",
//     authority: "https://login.microsoftonline.us/common",
//     redirectUri: window.location.origin + "/redirect",
//     postLogoutRedirectUri: "/",
//     navigateToLoginRequestUrl: true,
//   },
//   cache: {
//     cacheLocation: "localStorage",
//     storeAuthStateInCookie: true,
//   },
//   system: {
//     loggerOptions: {
//       loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
//         if (containsPii) return;
//         if (level === LogLevel.Error) console.error(message);
//       },
//     },
//   },
// };

// export const loginRequest = {
//   scopes: ["User.Read"],
// };


import { LogLevel } from "@azure/msal-browser";

// MSAL configuration
export const msalConfig = {
  auth: {
    clientId: "ffa0c20f-57a7-4174-8759-741bb3d9b83f", // SPA App Registration
    authority: "https://login.microsoftonline.us/common",
    redirectUri: window.location.origin + "/redirect",
    postLogoutRedirectUri: "/",
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error: console.error(message); break;
          //case LogLevel.Info: console.info(message); break;
          case LogLevel.Verbose: console.debug(message); break;
          case LogLevel.Warning: console.warn(message); break;
        }
      },
    },
  },
};

// Scopes for your backend API
export const loginRequest = {
  scopes: ["User.Read"],
};

